import React, { useState, useEffect } from 'react';
import { Text, Select } from "@geist-ui/core";
import { Users, X } from "@geist-ui/icons"; // Add X import
import './EnemySelector.css';

const EnemySelector = ({ 
  position, 
  onDragEnd, 
  onEnemySelect, 
  currentSection, 
  onClose,
  selectedTokenId = null 
}) => { // Add onClose and selectedTokenId props
  const [isDragging, setIsDragging] = useState(false);
  const [dragPos, setDragPos] = useState(position);
  const [selectedEnemy, setSelectedEnemy] = useState('');

  // Auto-select first enemy when section changes
  useEffect(() => {
    if (currentSection?.statblocks?.length > 0) {
      setSelectedEnemy(currentSection.statblocks[0].id);
    }
  }, [currentSection]);

  // Update the selection effect
  useEffect(() => {
    if (selectedTokenId) {
      const enemyStatblock = currentSection?.statblocks?.find(
        sb => sb.id.toLowerCase() === selectedTokenId.toLowerCase()
      );
      
      if (enemyStatblock) {
        setSelectedEnemy(enemyStatblock.id);
        onEnemySelect(enemyStatblock.image); // Pass the statblock image
      }
    }
  }, [selectedTokenId, currentSection, onEnemySelect]);

  // Dragging handlers
  const handleMouseDown = (e) => {
    if (e.target.classList.contains('enemy-selector-header')) {
      setIsDragging(true);
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setDragPos(prevPos => ({
        x: prevPos.x + e.movementX,
        y: prevPos.y + e.movementY
      }));
    }
  };

  const handleMouseUp = () => {
    if (isDragging) {
      setIsDragging(false);
      onDragEnd(dragPos);
    }
  };

  const handleEnemyChange = (value) => {
    setSelectedEnemy(value);
    const selectedStatblock = currentSection?.statblocks?.find(sb => sb.id === value);
    if (selectedStatblock) {
      onEnemySelect(selectedStatblock.image, selectedStatblock.id);
    }
  };

  return (
    <div 
      className="enemy-selector"
      style={{ 
        transform: `translate(${dragPos.x}px, ${dragPos.y + 80}px)`,
        cursor: isDragging ? 'grabbing' : 'auto'
      }}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      <div className="enemy-selector-header">
        <Users size={20} />
        <Text small>Enemies</Text>
        <button className="close-button" onClick={onClose}>
          <X size={20} />
        </button>
      </div>
      <div className="enemy-selector-content">
        {currentSection?.statblocks ? (
          <>
            <Select
              placeholder="Select Enemy"
              value={selectedEnemy}
              onChange={handleEnemyChange}
              width="100%"
            >
              {currentSection.statblocks.map(enemy => (
                <Select.Option key={enemy.id} value={enemy.id}>
                  {enemy.name}
                </Select.Option>
              ))}
            </Select>
            {selectedEnemy && (
              <div className="enemy-preview">
                <img 
                  src={currentSection.statblocks.find(e => e.id === selectedEnemy)?.image}
                  alt={currentSection.statblocks.find(e => e.id === selectedEnemy)?.name}
                  style={{ 
                    width: '100%',
                    height: 'auto',
                    marginTop: '12px',
                    borderRadius: '8px',
                    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
                    cursor: 'pointer'
                  }}
                />
              </div>
            )}
          </>
        ) : (
          <Text small style={{ padding: '0 16px' }}>Select a map to view available enemies</Text>
        )}
      </div>
    </div>
  );
};

export default EnemySelector;